export default __webpack_public_path__ + "static/media/art1.63a530ca.png";